import React from 'react';

class TextInput extends React.Component {
	constructor(props) {
		super(props);
		this.handleChange = this.handleChange.bind(this);
		this.state = { value : (this.props.value) ? this.props.value : '' };
	}

	handleChange(e) {
		this.setState({ value: e.target.value });

		if(this.props.handleChange) this.props.handleChange(e.target.value, this.props.dataId);
	}

	render() {
		const dataId = this.props.dataId || '';
		const type = (this.props.type) ? this.props.type : "text";
		
		var errorMessage = (this.props.error_str) ? (<div className='AlertBox Error' dangerouslySetInnerHTML={{__html : this.props.error_str}}></div>) : '';

		if(this.props.error_str) {
			console.log(this.props.error_str);
		}
		return (
			<div className='Text-Input'>
				{errorMessage}
				<input type={type} dataid={dataId} className={this.props.class} placeholder={this.props.placeholder} value={this.state.value} onChange={this.handleChange} />
			</div>
			);
	}
}

export default TextInput;